// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BkVu","type":"styles_type__araPy","choices":"styles_choices__yRcn3"};